import { cn, Text } from '@mntn/ui-components'
import { format } from 'date-fns'
import { DATE_FORMATS } from '../consts'

interface Props {
  date?: string
  className?: string
  variant?: 'dark'
}

export const DateCell = ({ date, className, variant }: Props) => {
  return (
    <Text
      variant="base-sm"
      inline
      className={cn('text-primary m-0', variant === 'dark' && 'text-primary-inverse', className)}
    >
      {date ? format(date, DATE_FORMATS.DISPLAY_DATE_SHORT) : '--'}
    </Text>
  )
}
